import { string, shape, bool } from "prop-types"
import { isPresent } from "utils/helpers"

const FooterDetails = ({ createdAt, createdBy, isCanceled, canceledOn }) => {
  return (
    <div className="font-size-5 c-secondary">
      Registered on {createdAt}
      {isPresent(createdBy) ? ` by ${createdBy.firstName} ${createdBy.lastName}` : ""}
      {isCanceled && <div className="mt-4p">Canceled on {canceledOn}</div>}
    </div>
  )
}

FooterDetails.propTypes = {
  createdAt: string,
  createdBy: shape({
    firstName: string.isRequired,
    lastName: string.isRequired
  }),
  isCanceled: bool,
  canceledOn: string
}

export default FooterDetails
